import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { Box } from "@mui/system";

import { services } from "@services";

import { ServiceListSection, ServiceTitle } from "./ServiceLinks.styled";

export const ServiceLinks = () => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignSelf: "flex-start",
        gap: "10px",
      }}
    >
      <ServiceListSection>
        {Object.entries(services[locale as "pl" | "en"])
          .filter(
            ([slug]) =>
              slug !== "arduino_development_services" &&
              slug !== "arduino_development_services_pl",
          )
          .map(([slug, serviceData], index) => {
            const service = serviceData as any;

            return (
              <span key={slug}>
                <Link href={`/services/${slug}`}>
                  <ServiceTitle>
                    {service?.title || slug.replace(/_/g, " ")}
                  </ServiceTitle>
                </Link>
                {index <
                  Object.entries(services[locale as "pl" | "en"]).length -
                    2 && <span className="px-2">•</span>}
              </span>
            );
          })}

        <span className="px-2">•</span>

        <Link href={`/iot`}>
          <ServiceTitle>Systemy IoT</ServiceTitle>
        </Link>

        <span className="px-2">•</span>

        <Link href={`/mvp`}>
          <ServiceTitle>Budowa MVP</ServiceTitle>
        </Link>

        <span className="px-2">•</span>

        <Link href={`/utrzymanie-i-audyt-oprogramowania`}>
          <ServiceTitle>Utrzymanie i audyt oprogramowania</ServiceTitle>
        </Link>

        <span className="px-2">•</span>

        <Link href={`/bluetooth-low-energy`}>
          <ServiceTitle>Bluetooth Low Energy</ServiceTitle>
        </Link>

        <span className="px-2">•</span>

        <Link href={`/aplikacje-mobilne-i-webowe`}>
          <ServiceTitle>Aplikacje mobilne i webowe</ServiceTitle>
        </Link>

        <span className="px-2">•</span>

        <Link href={`/aplikacje-bluetooth`}>
          <ServiceTitle>Aplikacje Bluetooth</ServiceTitle>
        </Link>

        <span className="px-2">•</span>

        <Link href={`/ibeacon-app-development`}>
          <ServiceTitle>iBeacon App Development</ServiceTitle>
        </Link>
      </ServiceListSection>
    </Box>
  );
};
